import { queryOptions, skipToken } from '@tanstack/react-query';

import { identify } from '../../api/passcode.api';
import { IDENTIFY_STALE_MS } from '../../constants/code';

export const passcodeKeys = {
  all: ['passcode-auth'] as const,
  identify: (identifier: string | null) => [...passcodeKeys.all, 'identify', identifier] as const,
};

export const identifyQueryOptions = (identifier: string | null) =>
  queryOptions({
    queryKey: passcodeKeys.identify(identifier),
    queryFn: identifier === null ? skipToken : ({ signal }) => identify(identifier, signal),
    staleTime: IDENTIFY_STALE_MS,
    retry: false,
  });
